import React, { Component, ReactElement } from "react";

// add other imports
import { classNames, } from "components/Utils";
import { Module, Icons, } from "components/Module";
import { DiceRoller, } from "components/DiceRoller";
import { Button, ButtonColor, ButtonStyle } from "components/FormControls";
import { Tracker, TrackerType, } from "components/Tracker";
import { Theming } from "components/Utils";

// styling
import "./style.scss";

export class App extends Component<{}> {
    public render(): ReactElement {
        const handleThemeClick = () => {
            const theme = Theming.getEffectiveTheme();
            theme === "light" ? Theming.setTheme("dark") : Theming.setTheme("light");
        };

        const mainCss = classNames([
            "__app__",
            "p-3",
        ]);

        const contentCss = classNames([
            "container",
            "bg-body-tertiary",
            "border",
            "rounded",
            "p-4",
        ]);

        return (
            <main className={mainCss}>
                <div className={contentCss}>
                    <Module label="Dice Roller" icon={Icons.DiceRoller}>
                        <DiceRoller />
                    </Module>

                    <hr />

                    <Module label="Health Tracker" isCollapsed={true} icon={Icons.HealthTracker}>
                        <Tracker type={TrackerType.Health} />
                    </Module>

                    <hr />

                    <Module label="Willpower Tracker" isCollapsed={true} icon={Icons.WillpowerTracker}>
                        <Tracker type={TrackerType.Willpower} />
                    </Module>

                    <hr />

                    <div className="d-flex justify-content-end">
                        <Button style={ButtonStyle.Outline} color={ButtonColor.Secondary} label="Toggle theme" onClick={handleThemeClick} />
                    </div>
                </div>
            </main>
        );
    }

    public componentDidMount(): void {
        Theming.setTheme(Theming.getEffectiveTheme());
    }
}

export default App;
